<div class="demo-container">
  <div class="demo-header">
    <h1>Custom Date Range Picker Demo</h1>
    <p>Showcasing the new modern date range picker component with clean UI design</p>
  </div>

  <form [formGroup]="demoForm" (ngSubmit)="onSubmit()" class="demo-form">
    <div class="demo-section">
      <h2>Basic Date Range Picker</h2>
      <div class="form-group">
        <label>Select a date range:</label>
        <app-custom-date-range-picker 
          formControlName="basicRange"
          placeholder="Select Date Range"
          (dateRangeChange)="onDateRangeChange($event)">
        </app-custom-date-range-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Date Range Picker with Min/Max Date</h2>
      <div class="form-group">
        <label>Select date range between 2020-2030:</label>
        <app-custom-date-range-picker 
          formControlName="withMinMax"
          placeholder="Select Date Range"
          [minDate]="minDate"
          [maxDate]="maxDate"
          (dateRangeChange)="onDateRangeChange($event)">
        </app-custom-date-range-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Disabled Date Range Picker</h2>
      <div class="form-group">
        <label>Disabled date range picker:</label>
        <app-custom-date-range-picker 
          formControlName="disabledRange"
          placeholder="Select Date Range"
          [disabled]="true">
        </app-custom-date-range-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Custom Placeholder</h2>
      <div class="form-group">
        <label>Custom placeholder text:</label>
        <app-custom-date-range-picker 
          formControlName="customPlaceholder"
          placeholder="Choose your preferred date range"
          startDatePlaceholder="Start Date"
          endDatePlaceholder="End Date"
          (dateRangeChange)="onDateRangeChange($event)">
        </app-custom-date-range-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Pre-selected Date Range</h2>
      <div class="form-group">
        <label>Date range with pre-selected values:</label>
        <app-custom-date-range-picker 
          formControlName="preSelectedRange"
          placeholder="Select Date Range"
          (dateRangeChange)="onDateRangeChange($event)">
        </app-custom-date-range-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Form Values</h2>
      <div class="form-values">
        <pre>{{ demoForm.value | json }}</pre>
      </div>
    </div>

    <div class="demo-actions">
      <button type="submit" class="btn btn-primary">Submit Form</button>
      <button type="button" class="btn btn-secondary" (click)="clearAllRanges()">Clear All Ranges</button>
    </div>
  </form>
</div> 